// extracted by mini-css-extract-plugin
export var addToCartButton = "_u3-b";
export var arrowButtonContainer = "_u3-9";
export var arrowButtonIcon = "_u3-a";
export var carouselArrowButton = "_u3-6";
export var carouselElementContainer = "_u3-1";
export var left = "_u3-7";
export var productDisplayCarouselContainer = "_u3-0";
export var productTileContainer = "_u3-2";
export var productTileImage = "_u3-4";
export var productTileImageContainer = "_u3-3";
export var productTileTitle = "_u3-5";
export var right = "_u3-8";
export var sliderOverflow = "_u3-c";